export default __webpack_public_path__ + "static/media/contact.b7a5644a.svg";